import { AlertCircle, AlertTriangle, CheckCircle, Info, X } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { Message } from '../../../store/message';
import Button from '../Button';

interface AlertProps {
  message: Message;
  onClose: () => void;
}

const variants = {
  info: {
    icon: Info,
    className: 'bg-blue-50 text-blue-800 dark:bg-blue-900/30 dark:text-blue-200',
  },
  success: {
    icon: CheckCircle,
    className: 'bg-green-50 text-green-800 dark:bg-green-900/30 dark:text-green-200',
  },
  warning: {
    icon: AlertTriangle,
    className: 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-200',
  },
  error: {
    icon: AlertCircle,
    className: 'bg-red-50 text-red-800 dark:bg-red-900/30 dark:text-red-200',
  },
};

function Alert({ message, onClose }: AlertProps) {
  const variant = variants[message.variant || 'info'];
  const Icon = variant.icon;

  return (
    <div className="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
      <div className="p-4">
        <div className={cn('flex items-start', variant.className)}>
          <div className="flex-shrink-0">
            <Icon className="h-6 w-6" />
          </div>
          <div className="ml-3 w-0 flex-1 pt-0.5">
            <p className="text-sm font-medium">{message.title}</p>
            {message.content && (
              <p className="mt-1 text-sm">{message.content}</p>
            )}
            <div className="mt-3 flex space-x-2">
              <Button
                size="sm"
                onClick={onClose}
              >
                OK
              </Button>
            </div>
          </div>
          <div className="ml-4 flex flex-shrink-0">
            <button
              type="button"
              className="inline-flex rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
              onClick={onClose}
            >
              <span className="sr-only">Fechar</span>
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Alert;